// Gallery data for the Commercial & Industrial tracks.
//
// These galleries are built from the service imagery, which is now real
// Reformity project photography — so every gallery tile represents work the
// company actually performed.
//
// EXCEPTION: the services listed in STOCK_ONLY_SLUGS have no real Reformity
// photos on file (we have never photographed a snow/ice call). Their service
// pages still carry illustrative stock imagery, but they are withheld from the
// galleries — a gallery tile is a claim of past work, and stock photography
// cannot back that claim. Shoot those jobs, swap the images, then delete the
// slug from this list.

import { COMMERCIAL_SERVICES_DATA } from "@/data/commercial-services";
import { INDUSTRIAL_SERVICES_DATA } from "@/data/industrial-services";

const STOCK_ONLY_SLUGS = new Set([
    "snow-ice-management",
    "snow-ice-management-industrial",
]);

function buildTrackGallery(servicesData) {
    const categories = [{ id: "all", label: "All" }];
    const items = [];
    Object.values(servicesData).forEach((s) => {
        if (STOCK_ONLY_SLUGS.has(s.slug)) return;
        categories.push({ id: s.slug, label: s.name });
        if (s.heroImage) {
            items.push({
                id: `${s.slug}-hero`,
                category: s.slug,
                title: s.name,
                city: "GTA",
                image: s.heroImage,
            });
        }
        (s.materials || []).forEach((m, i) => {
            if (!m.image) return;
            items.push({
                id: `${s.slug}-m${i}`,
                category: s.slug,
                title: m.name || s.name,
                city: "GTA",
                image: m.image,
            });
        });
    });
    return { categories, items };
}

export const COMMERCIAL_GALLERY = buildTrackGallery(COMMERCIAL_SERVICES_DATA);
export const INDUSTRIAL_GALLERY = buildTrackGallery(INDUSTRIAL_SERVICES_DATA);

export const TRACK_GALLERY = {
    commercial: COMMERCIAL_GALLERY,
    industrial: INDUSTRIAL_GALLERY,
};
